import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "songer",
  props: {
    songerList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 点击歌手跳转详情页 */

    var songerClick = function songerClick(id) {
      router.push("/main/artistdetail/".concat(id));
    };

    return {
      songerClick: songerClick
    };
  },
  components: {}
});